import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const AssayType = ({ assayType, handleChange, xplans, assays, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="assayType" className="planField">
            <GroupBDRBiologists />
            <Autocomplete
                name="assayType"
                multiple
                freeSolo
                autoSelect
                options={assays}
                value={assayType ? assayType.split(",") : []}
                onChange={(_, newValue) => handleChange("assayType", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.assayType}
                        InputLabelProps={{
                            shrink: true,
                            required: required.includes("assayType")
                        }}
                        required={required.includes("assayType")}
                    />
                }
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"assayType"} />}
        </div>
    );
};

export default AssayType;